import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../components/Button";
import { Input } from "../components/Input";
import { requestPasswordReset } from "../services/api";

export default function ForgotPassword() {
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await requestPasswordReset({ email: email.trim() });
      setSubmitted(true);
    } catch {
      // Show generic message even on network error to avoid leaking info
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen grid place-items-center bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white shadow-lg p-8 text-center">
        <img
          src="/favicon.png"
          alt="Zero Riscuri Logo"
          className="mx-auto h-24 w-24 object-contain mb-4"
        />

        <h1 className="text-2xl font-bold text-slate-900 mb-1">
          {t("forgot_password.title")}
        </h1>
        <p className="text-sm text-slate-500 mb-6">
          {t("forgot_password.subtitle")}
        </p>

        {submitted ? (
          <div className="space-y-4">
            <div className="text-sm text-green-700 bg-green-50 border border-green-200 rounded-xl px-4 py-3">
              {t("forgot_password.success_message")}
            </div>
            <Link
              to="/login"
              className="block text-sm text-blue-600 hover:text-blue-800 underline mt-2"
            >
              {t("forgot_password.back_to_login")}
            </Link>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-4 text-left">
            <div>
              <label className="block text-xs text-slate-500 font-medium mb-1">
                {t("forgot_password.email_label")}
              </label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t("forgot_password.email_placeholder")}
                required
              />
            </div>

            {error && (
              <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-xl px-3 py-2">
                {error}
              </div>
            )}

            <Button disabled={loading} className="w-full justify-center">
              {loading
                ? t("forgot_password.btn_loading")
                : t("forgot_password.btn_submit")}
            </Button>

            <div className="text-center pt-1">
              <Link
                to="/login"
                className="text-sm text-blue-600 hover:text-blue-800 underline"
              >
                {t("forgot_password.back_to_login")}
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
